import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { CssBaseline, Container } from '@mui/material';
import Sidebar from './components/sidebar/Sidebar';
import Dashboard from './components/dashboard/dashboard';
import Header from './components/header/header';
import OCRProcesses from './components/OcrProcesses/OcrProcesses';
import { Outlet } from 'react-router-dom';

import Vendor from './components/OcrProcesses/ocrVendor';
import Login from './Screens/Public/Login';
import { AuthProvider, useAuth } from './context/AuthContext';
import SuperAdminDashboard from './Pages/SuperAdmin/SAdminDashboard';
import CreateOrganization from './Pages/SuperAdmin/CreateOrganization';
import ManageVendors from './Pages/SuperAdmin/ManageVendors';
import SuperAdminLayout from './Pages/SuperAdmin/Layouts/SuperAdminLayout';

const MainLayout = ({ open, handleDrawerOpen, setOpen, children }) => (
  <div style={{ display: 'flex' }}>
    <CssBaseline />
    <Header handleDrawerOpen={handleDrawerOpen} />
    <Sidebar open={open} setOpen={setOpen} />
    <Container style={{ marginTop: '80px', padding: '20px' }}>
      {children}
    </Container>
  </div>
);


const MainLayoutWrapper = () => {
  const [open, setOpen] = useState(true);

  const handleDrawerOpen = () => {
    setOpen(!open);
  };

  return (
    <MainLayout open={open} handleDrawerOpen={handleDrawerOpen} setOpen={setOpen}>
      <Outlet />
    </MainLayout>
  );
};


function AuthenticatedRoutes() {
  const [open, setOpen] = useState(true);

  const handleDrawerOpen = () => {
    setOpen(!open);
  };

  return (
    <MainLayout open={open} handleDrawerOpen={handleDrawerOpen}>
      <Outlet />
    </MainLayout>
  );
}
 

function App() {
  const [open, setOpen] = useState(true);

  const handleDrawerOpen = () => {
    setOpen(!open);
  };

  return (
    <Router>
            <AuthProvider>
            <AppRoutes/>
      </AuthProvider>
    </Router>
  );
}

function AppRoutes() {
  const { isAuthenticated, loading ,user} = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }
 

  return (
    <Routes>
      <Route 
        path="/login" 
        element={!isAuthenticated ? <Login /> : <Navigate to={user?.role === 'superadmin' ? '/super-admin' : '/dashboard'} replace />} 
      />

      {/* Super Admin Routes */}
      <Route
        path="/super-admin"
        element={
          isAuthenticated && user?.role === 'superadmin' ? (
            <SuperAdminLayout />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      >
        <Route index element={<SuperAdminDashboard />} />
        <Route path="dashboard" element={<SuperAdminDashboard />} />
        <Route path="create-organization" element={<CreateOrganization />} />
        <Route path="manage-vendors" element={<ManageVendors />} />
      </Route>

      {/* Regular Admin Routes */}
      <Route
        path="/*"
        element={

          isAuthenticated && user?.role === 'admin' ? (
            <MainLayoutWrapper />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="ocr-processes" element={<OCRProcesses />} />
        <Route path="ocr-vendors" element={<Vendor />} />
      </Route>

     
       <Route
        path="/"
        element={
          <Navigate 
            to={
              isAuthenticated 
                ? user?.role === 'superadmin' 
                  ? "/super-admin/dashboard" 
                  : "/dashboard" 
                : "/login"
            } 
            replace 
          />
        }
      />
    </Routes>
  );
}

export default App;